import { createEvent, createStore } from 'effector'

export const setCtvLandingRegion = createEvent<string>()

export const $ctvLandingRegion = createStore<string | null>(null).on(
  setCtvLandingRegion,
  (_, landingRegion) => {
    return landingRegion?.toLowerCase() ?? ''
  }
)

/** CTV URL segment, e.g. `nigeria` — needed where alias alone is ambiguous (Africa sub-regions). */
export const setCtvLandingPageSlug = createEvent<string | null>()

export const $ctvLandingPageSlug = createStore<string | null>(null).on(
  setCtvLandingPageSlug,
  (_, slug) => (slug ? slug.toLowerCase() : null)
)
